// import * as Sentry from '@sentry/browser';

// Sentry.init({
//     // dsn: 'https://fa3d6bf6765440ecbc634c2b1db6f5a0@logtracker.orange.pl/4',
//     dsn: 'https://fa3d6bf6765440ecbc634c2b1db6f5a0@sentry.webproxy.corpnet.pl/4',

//     // Alternatively, use `process.env.npm_package_version` for a dynamic release version
//     // if your build tool supports it.
//     release: 'my-project-name@2.3.12',
//     integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],

//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 1.0,

//     // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
//     tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],

//     // Capture Replay for 10% of all sessions,
//     // plus for 100% of sessions with an error
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1.0
// });

const isDebug = () => {
    return window.WC?._debug;
};

const Logger = {
    prefix: 'WC BASE:',
    info: (...args) => {
        console.info(Logger.prefix, ...args);
    },
    log: (...args) => {
        if (isDebug()) {
            console.log(Logger.prefix, ...args);
        }
    },
    error: (...args) => {
        console.error(Logger.prefix, ...args);
    },
    logToGWE: (event, payload) => {
        if (!window._gt) {
            return;
        }
        window._gt.push([
            'event',
            event,
            {
                data: payload
            }
        ]);
    }
};

export default Logger;
